import { ApiRequester } from "../ApiRequester"

interface RequestDataShape {
	id: string
}

export async function studentDeleteApi(payload: RequestDataShape, token: string) {
	const endpoint = "/student/delete/v1"
	const requester = new ApiRequester<RequestDataShape, void>(endpoint)
	await requester.sendRequest(payload, token)
}
